import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Benefits from "./pages/Benefits";
import Servicios from "./pages/Servicios";
import Team from "./pages/Team";
import Socios from "./pages/Socios";
import Ventajas from "./pages/Ventajas";
import News from "./pages/News";
import Contact from "./pages/Contact";
import NewsArticle from "./pages/NewsArticle";
import NewsArchive from "./pages/NewsArchive";
import { LanguageProvider } from "./context/LanguageContext";
import { ThemeProvider } from "./context/ThemeContext";
import { PortfolioFilterProvider } from "./context/PortfolioFilterContext";

function Landing() {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        <div id="home"><Home /></div>
        <div id="socios"><Socios /></div>
        <div id="about"><About /></div>
        <div id="benefits"><Benefits /></div>
        <div id="servicios"><Servicios /></div>
        <div id="ventajas"><Ventajas /></div>
        <div id="team"><Team /></div>
        <div id="news"><News /></div>
        <div id="contact"><Contact /></div>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <PortfolioFilterProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/news" element={<NewsArchive />} />
              <Route path="/news/:id" element={<NewsArticle />} />
            </Routes>
          </BrowserRouter>
        </PortfolioFilterProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
